export default "<p>edit-coa-type works!</p>\n";